/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ats_Score_Hide_TipsInputs */

const en_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide Tips`)
};

const de_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipps ausblenden`)
};

const fr_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masquer les conseils`)
};

const es_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocultar consejos`)
};

const it_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nascondi suggerimenti`)
};

const nl_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tips verbergen`)
};

const pl_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukryj wskazówki`)
};

const fi_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piilota vinkit`)
};

const da_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjul tips`)
};

const sv_ats_score_hide_tips = /** @type {(inputs: Ats_Score_Hide_TipsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dölj tips`)
};

/**
* | output |
* | --- |
* | "Hide Tips" |
*
* @param {Ats_Score_Hide_TipsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const ats_score_hide_tips = /** @type {((inputs?: Ats_Score_Hide_TipsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ats_Score_Hide_TipsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ats_score_hide_tips(inputs)
	if (locale === "fr") return fr_ats_score_hide_tips(inputs)
	if (locale === "es") return es_ats_score_hide_tips(inputs)
	if (locale === "it") return it_ats_score_hide_tips(inputs)
	if (locale === "nl") return nl_ats_score_hide_tips(inputs)
	if (locale === "pl") return pl_ats_score_hide_tips(inputs)
	if (locale === "fi") return fi_ats_score_hide_tips(inputs)
	if (locale === "da") return da_ats_score_hide_tips(inputs)
	if (locale === "sv") return sv_ats_score_hide_tips(inputs)
	return en_ats_score_hide_tips(inputs)
});